import ROUTES from "./routes";

const HOME_ECOMMERCE_PAYMENT = 3846;
const HOME_ECOMMERCE_CUSTOM_PLAN = 3844;
const HOME_ECOMMERCE_INFO_HOUSING = 3842;

export const CODES_CRM_BY_URL = {
    [ROUTES.HOME_INSURANCE.STEP5]: HOME_ECOMMERCE_PAYMENT,
    [ROUTES.HOME_INSURANCE.STEP3]: HOME_ECOMMERCE_CUSTOM_PLAN,
    [ROUTES.HOME_INSURANCE.STEP2]: HOME_ECOMMERCE_INFO_HOUSING,
};
